<div class="required-text">
  {{ getMinRequirementsText(cv) }}
  <span *ngIf="'expireProfiles' | preventHardcoding">
    {{ 'expireProfilesHint' | preventHardcoding }}
  </span>
</div>
